module.exports = __webpack_public_path__ + "static/media/app-image.999a99a1.png";